<!-- Backdrop -->
<div
  class="ai-chat-drawer__backdrop"
  [class.ai-chat-drawer__backdrop--visible]="open"
  (click)="close()"
  aria-hidden="true"
></div>

<!-- Drawer panel -->
<div
  class="ai-chat-drawer__panel"
  [class.ai-chat-drawer__panel--open]="open"
  role="dialog"
  aria-modal="true"
>
  <div class="ai-chat-drawer__panel-header">
    <ui-button *ngIf="isHistoryOpen" type="transparent" icon="arrow-left-cc" iconSize="medium" (click)="isHistoryOpen = false"></ui-button>
    <span class="ai-chat-drawer__title">{{ (!isHistoryOpen ? 'ai_chat.title' : 'ai_chat.conversation') | translate }}</span>
    <div class="ai-chat-drawer__panel-header-actions">
      <ui-button
        *ngIf="!isHistoryOpen"
        class="ai-chat-drawer__panel-header-history-btn"
        type="transparent"
        icon="quote_history"
        iconSize="large"
        [title]="'ai_chat.history' | translate"
        (click)="toggleHistory()"
      ></ui-button>
      <ui-button
        class="ai-chat-drawer__panel-header-new-btn"
        type="transparent"
        icon="plus-cc"
        [label]="'ai_chat.new_conversation' | translate"
        (click)="createNewConversation()"
      ></ui-button>
    </div>
  </div>

  <app-chat-history
    *ngIf="isHistoryOpen"
    (conversationSelected)="onConversationSelected($event)"
  ></app-chat-history>

  <app-chat-window
    *ngIf="!isHistoryOpen"
    [conversation]="activeConversation$ | async"
    [loading]="(activeConversationLoading$ | async) ?? false"
  ></app-chat-window>
</div>
